export default {
  namespaced: true,
  state: {
    formSelections: null,
  },
  getters: {},
  mutations: {
    setFormSelections(state, formSelection) {
      // Set the new default org in local storage so we can check it on refresh instead of using user default
      if (formSelection) {
        localStorage.setItem('assessmentForm', formSelection)
      } else {
        localStorage.removeItem('current_default_organization_id');
      }
      state.formSelections = formSelection;
    },
  },
  actions: {}
};
